
import { Task } from '@/types/api/task'
import { defineComponent, PropType } from 'vue'
import { downloadFile } from '@/core/services/http-service'
import { trackAddToCalendar } from '@/core/services/tracking-service'

export default defineComponent({
  props: {
    task: { type: Object as PropType<Task>, required: true }
  },
  setup(props) {
    function addToCalendar() {
      downloadFile('request/calendar_event', `${props.task.startDate}.ics`, { taskId: props.task.taskId })
      trackAddToCalendar()
    }

    return {
      addToCalendar
    }
  }
})

